const Pagination = ({ paginationMeta, onPageChange }) => {
  if (!paginationMeta) {
    return null
  }

  const { currentPage, lastPage } = paginationMeta
  if (!lastPage || lastPage <= 1) {
    return null
  }

  const hasNextPage = currentPage < lastPage
  const hasPreviousPage = currentPage > 1
  return (
    <div className="flex justify-between items-center mt-6">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!hasPreviousPage}
        className="px-4 py-2 rounded bg-secondary-700 text-white text-sm font-medium disabled:opacity-50"
      >
        Previous
      </button>

      <span className="text-sm text-foreground">
        Page {currentPage} of {lastPage}
      </span>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!hasNextPage}
        className="px-4 py-2 rounded bg-secondary-700 text-white text-sm font-medium disabled:opacity-50"
      >
        Next
      </button>
    </div>
  )
}

export default Pagination
